webpackJsonp([1],{

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea881b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea881b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea881b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Setup__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ActiveConversations__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Conversation__ = __webpack_require__(346);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Setup: __WEBPACK_IMPORTED_MODULE_3__components_Setup__["a" /* default */],
    ActiveConversations: __WEBPACK_IMPORTED_MODULE_4__components_ActiveConversations__["a" /* default */],
    Conversation: __WEBPACK_IMPORTED_MODULE_5__components_Conversation__["a" /* default */]
  },
  name: 'dashboard',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userfirstname', 'userlastname', 'useremail', 'usercolor', 'userlevel', 'userTwilioAccountSID', 'teamTwilioAccountSID', 'teamTwilioAuthToken', 'teamTwilioSMSNumber', 'teamname', 'teamlastupdate', 'teamlastcommfrom', 'selectedcontactSMS', 'forceConversationUpdate', 'globalcontacthistory'])),
  data: function data() {
    return {
      loading: true,
      sending: false
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      console.log('Logging out!');
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function () {
        _this.$router.replace('login');
      });
    },
    updateScroll: function updateScroll() {
      if (!this.scrolled) {
        var element = document.getElementById('messageswindow');
        element.scrollTop = element.scrollHeight;
      }
    },
    reloadPage: function reloadPage() {
      console.log('reload clicked.');
      location.reload();
    }
  }
});

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import firebase from 'firebase'



/* harmony default export */ __webpack_exports__["a"] = ({
  // name: 'setup',
  data: function data() {
    return {
      showSetup: false,
      sending: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__["b" /* mapFields */])(['userfirstname', 'userlastname', 'useremail', 'usercolor', 'userlevel', 'userTwilioAccountSID', 'teamTwilioAccountSID', 'teamTwilioAuthToken', 'teamTwilioSMSNumber', 'teamname', 'teamlastupdate'])),
  watch: {
    showSetup: function showSetup(newshowSetup, oldshowSetup) {
      console.log('oldshowSetup: ' + oldshowSetup);
      console.log('newshowSetup: ' + newshowSetup);
    }
  },
  methods: {
    saveSetup: function saveSetup() {
      this.sending = true;
      console.log(this.userdata);
      __WEBPACK_IMPORTED_MODULE_1__services_firebase__["a" /* default */].collection('users').doc(this.userdata.email).update({
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        color: this.user.color,
        level: this.user.level,
        TwilioAccountSID: this.user.TwilioAccountSID
      });
      console.log('User data saved');
      __WEBPACK_IMPORTED_MODULE_1__services_firebase__["a" /* default */].collection('teams').doc(this.user.TwilioAccountSID).update({
        TwilioAccountSID: this.team.TwilioAccountSID,
        TwilioAuthToken: this.team.TwilioAuthToken,
        TwilioSMSNumber: this.team.TwilioSMSNumber,
        teamname: this.team.teamname
      });
      console.log('Team data saved');
      this.sending = false;
      this.showSetup = false;
    }
  }
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewMessage__ = __webpack_require__(324);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'

// import axios from 'axios'




// var updateContactNamesDebounced = _.debounce(function (mythis) { // YES, this will always be debounced
//   mythis.$store.state.globalcontacthistorywithnames = mythis.$store.state.globalcontacthistory
// }, 1000)

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NewMessage: __WEBPACK_IMPORTED_MODULE_4__components_NewMessage__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userfirstname', 'userlastname', 'useremail', 'usercolor', 'userlevel', 'userTwilioAccountSID', 'teamTwilioAccountSID', 'teamTwilioAuthToken', 'teamTwilioSMSNumber', 'teamname', 'forceConversationUpdate']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["b" /* mapFields */])(['selectedcontactSMS', 'teamlastupdate', 'globalcontacthistory'])),
  mounted: function mounted() {
    console.log('Mounted ActiveConversation');
    console.log(this.teamTwilioSMSNumber);
    // setTimeout(this.updateContactNames(), 25000)
  },
  updated: function updated() {
    // this.updateContactNames()
  },

  methods: {
    updateContactNames: function updateContactNames() {
      console.log('Updating contact names...');
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__services_firebase__["a" /* default */].collection('teams').doc(this.$store.state.teamTwilioAccountSID).collection('contacts').get().then(function (querySnapshot) {
        console.log('updateContactNames - then');
        console.log(self.$store.state.globalcontacthistory);
        querySnapshot.forEach(function (doc) {
          for (var i = 0; i < self.$store.state.globalcontacthistory.length; i++) {
            if (self.$store.state.globalcontacthistory[i]['contactnumber'] === doc.id) {
              self.$store.state.globalcontacthistory[i].name = doc.data().name;
            }
          }
        });
      });
    },
    selectContact: function selectContact(contactnumber) {
      console.log('Switching to: ' + contactnumber);
      this.selectedcontactSMS = contactnumber;
      __WEBPACK_IMPORTED_MODULE_1__services_firebase__["a" /* default */].collection('teams').doc(this.teamTwilioAccountSID).collection('contacts').doc(contactnumber).update({
        lastviewed: Math.floor(Date.now() / 1000)
      });
    },
    saveName: function saveName(contactname, contactnumber) {
      var _this = this;

      console.log(contactname + ' -- ' + contactnumber);
      console.log(this.teamTwilioAccountSID);
      __WEBPACK_IMPORTED_MODULE_1__services_firebase__["a" /* default */].collection('teams').doc(this.teamTwilioAccountSID).collection('contacts').doc(contactnumber).update({
        name: contactname
      }).then(function () {
        console.log('Updated Name');
      }).catch(function (error) {
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_1__services_firebase__["a" /* default */].collection('teams').doc(_this.teamTwilioAccountSID).collection('contacts').doc(contactnumber).set({
          name: contactname
        });
      });
    }
  },
  watch: {
    teamlastupdate: function teamlastupdate(newdata, olddata) {
      if (!newdata === olddata) {
        this.$store.dispatch('getContactHistory');
      }
    },
    globalcontacthistory: function globalcontacthistory(newdata, olddata) {
      this.$store.dispatch('getCallerIDnames');
      setTimeout(this.updateContactNames(), 500);
    }
  }
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sendNew',
  data: function data() {
    return {
      showSendNew: false,
      sending: false,
      sendEndpoint: 'https://api.cvstech.com/twilio/sendmessage',
      areacode: '217',
      prefix: '',
      number: '217',
      message: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userfirstname', 'userlastname', 'useremail', 'usercolor', 'userlevel', 'userTwilioAccountSID', 'teamTwilioAccountSID', 'teamTwilioAuthToken', 'teamTwilioSMSNumber', 'teamname', 'teamlastupdate', 'teamlastcommfrom']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["b" /* mapFields */])(['selectedcontactSMS', 'forceConversationUpdate'])),
  watch: {
    showSendNew: function showSendNew(newshowSendNew, oldshowSendNew) {
      var _this = this;

      console.log('oldshowSendNew: ' + oldshowSendNew);
      console.log('newshowSendNew: ' + newshowSendNew);
      if (newshowSendNew) {
        console.log(this.$refs);
        // this.$refs.prefixfield.$el.focus()
        setTimeout(function () {
          _this.$refs.numberfield.$el.focus();
        }, 500);
      }
    }
  },
  created: function created() {
    this.forceConversationUpdate = false;
  },

  methods: {
    sendMessage: function sendMessage() {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.sendEndpoint, {
        sid: this.teamTwilioAccountSID,
        token: this.teamTwilioAuthToken,
        to: '+1' + this.number,
        body: this.message,
        from: this.teamTwilioSMSNumber
      }).catch(function (error) {
        console.log('-----error-------');
        console.log(error);
      });
      this.message = '';
      this.showSendNew = false;
      this.forceConversationUpdate = true;
      this.selectedcontactSMS = '+1' + this.number;
      // setTimeout(() => { this.updateScroll() }, 500)
    },
    nextWhenFull: function nextWhenFull(count, fieldreference) {
      console.log('event');
      console.log(this.target);
      console.log('count');
      console.log(count);
      console.log('field');
      console.log(fieldreference);
      // var elem = document.getElementById(fieldreference)
      // if (elem) {
      //   console.log(elem.value)
      //   // if (elem.value.length === count) {
      //   //   console.log('next!')
      //   // }
      // }
    }
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      messages: null,
      endpoint: 'https://api.cvstech.com/twilio/messages/',
      sendEndpoint: 'https://api.cvstech.com/twilio/sendmessage',
      outgoing: '',
      scrolled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userfirstname', 'userlastname', 'useremail', 'usercolor', 'userlevel', 'userTwilioAccountSID', 'teamTwilioAccountSID', 'teamTwilioAuthToken', 'teamTwilioSMSNumber', 'teamname', 'teamlastupdate', 'teamlastcommfrom']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["b" /* mapFields */])(['selectedcontactSMS', 'forceConversationUpdate'])),
  methods: {
    getMessages: function getMessages() {
      var _this = this;

      console.log('Getting messages... ' + this.teamTwilioSMSNumber + '/' + this.selectedcontactSMS);
      if (this.teamTwilioAccountSID) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.endpoint + this.teamTwilioSMSNumber + '/' + this.selectedcontactSMS, {
          sid: this.teamTwilioAccountSID,
          token: this.teamTwilioAuthToken
        }).then(function (response) {
          _this.messages = response.data;
          console.log(_this.messages);
        }).catch(function (error) {
          console.log('-----error-------');
          console.log(error);
        });
      } else {
        console.log('State data not ready yet...');
      }
      this.updateScroll();
      console.log(this.messages);
    },
    getFloat: function getFloat(direction) {
      var computedFloat;
      computedFloat = direction === 'inbound' ? 'left md-accent' : 'right md-primary';
      // console.log("Computed Float: " + computedFloat);
      return computedFloat;
    },
    configArrow: function configArrow(direction) {
      var computedArrowConfig;
      computedArrowConfig = direction === 'inbound' ? 'arrowin' : 'arrowout';
      return computedArrowConfig;
    },
    updateScroll: function updateScroll() {
      var elem = document.getElementById('messageswindow');
      if (elem) {
        elem.scrollTop = elem.scrollHeight;
      }
    },
    sendMessage: function sendMessage() {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.sendEndpoint, {
        sid: this.teamTwilioAccountSID,
        token: this.teamTwilioAuthToken,
        to: this.selectedcontactSMS,
        body: this.outgoing,
        from: this.teamTwilioSMSNumber
      }).catch(function (error) {
        console.log('-----error-------');
        console.log(error);
      });
      this.messages.push({
        body: this.outgoing,
        dateSent: Date.now() / 1000,
        direction: 'outbound-api',
        from: this.teamTwilioSMSNumber,
        mediaURL: '',
        sid: '',
        status: 'unknown',
        to: this.selectedcontactSMS,
        url: ''
      });
      // setTimeout(this.forceConversationUpdate = true, 2000)
      this.outgoing = '';
    }
  },
  updated: function updated() {
    this.updateScroll();
  },

  watch: {
    selectedcontactSMS: function selectedcontactSMS(newdata, olddata) {
      this.messages = [];
      console.log('Selected contact changed');
      // console.log('old: ' + olddata + ' new: ' + newdata)
      this.getMessages();
    },
    teamlastupdate: function teamlastupdate(newdata, olddata) {
      console.log('Last update refreshed.');
      this.getMessages();
    },
    forceConversationUpdate: function forceConversationUpdate(newdata, olddata) {
      this.forceConversationUpdate = false;
      this.getMessages();
    }
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      email: '',
      password: '',
      errormessage: '',
      showSnackbar: false
    };
  },
  methods: {
    login: function login(e) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        // alert(`You are logged in as ${user.email}`)
        _this.$router.go({ path: _this.$router.path });
      }, function (err) {
        _this.errormessage = err.message;
        _this.showSnackbar = true;
      });
      e.preventDefault();
    }
  }
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signup',
  data: function data() {
    return {
      email: '',
      password: '',
      errormessage: '',
      showSnackbar: false
    };
  },
  methods: {
    maybesignup: function maybesignup(e) {
      if (this.password) this.signup(e);
    },
    signup: function signup(e) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
        // alert(`You are logged in as ${user.email}`)
        _this.$router.go({ path: _this.$router.path });
      }, function (err) {
        _this.errormessage = err.message;
        _this.showSnackbar = true;
      });
      e.preventDefault();
    }
  }
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_min_css__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_dist_theme_default_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_dist_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_material_dist_theme_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_resource__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(364);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var app = void 0;
__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
      store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
      template: '<App/>',
      components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('readableTime', function (t) {
  var a = new Date(t * 1000);
  var today = new Date();
  var yesterday = new Date(Date.now() - 86400000);
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours() > 12 ? a.getHours() - 12 : a.getHours();
  if (hour === 0) {
    hour = '12';
  }
  var min = ('0' + a.getMinutes()).slice(-2);
  var amPm = a.getHours() >= 12 ? 'PM' : 'AM';
  if (a.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
    return 'Today, ' + hour + ':' + min + ' ' + amPm;
  } else if (a.setHours(0, 0, 0, 0) === yesterday.setHours(0, 0, 0, 0)) {
    return 'Yesterday, ' + hour + ':' + min + ' ' + amPm;
  } else if (year === today.getFullYear()) {
    return month + ' ' + date + ', ' + hour + ':' + min + ' ' + amPm;
  } else {
    return month + ' ' + date + ' ' + year + ', ' + hour + ':' + min + ' ' + amPm;
  }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dbad26e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dbad26e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8d9730_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__ = __webpack_require__(321);
function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b8d9730"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8d9730_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',{on:{"click":function($event){_vm.showSetup = true}}},[_c('md-icon',[_vm._v("settings")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Setup")]),_vm._v(" "),_c('md-dialog',{attrs:{"md-active":_vm.showSetup,"md-click-outside-to-close":false},on:{"update:mdActive":function($event){_vm.showSetup=$event}}},[_c('md-dialog-title',[_vm._v("Setup")]),_vm._v(" "),_c('form',{staticClass:"md-layout",on:{"submit":function($event){$event.preventDefault();return _vm.saveSetup($event)}}},[_c('md-card',{staticClass:"setup"},[_c('md-tabs',{attrs:{"md-alignment":"fixed"}},[_c('md-tab',{attrs:{"id":"tab-user","md-label":"User","md-icon":"person"}},[_c('md-field',[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('md-input',{model:{value:(this.userfirstname),callback:function ($$v) {_vm.$set(this, "userfirstname", $$v)},expression:"this.userfirstname"}})],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('md-input',{model:{value:(this.userlastname),callback:function ($$v) {_vm.$set(this, "userlastname", $$v)},expression:"this.userlastname"}})],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('md-input',{model:{value:(this.useremail),callback:function ($$v) {_vm.$set(this, "useremail", $$v)},expression:"this.useremail"}})],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Color")]),_vm._v(" "),_c('md-input',{model:{value:(this.usercolor),callback:function ($$v) {_vm.$set(this, "usercolor", $$v)},expression:"this.usercolor"}})],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Account Level")]),_vm._v(" "),_c('md-input',{model:{value:(this.userlevel),callback:function ($$v) {_vm.$set(this, "userlevel", $$v)},expression:"this.userlevel"}})],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"tab-team","md-label":"Team","md-icon":"group"}},[_c('md-field',[_c('label',[_vm._v("Team Name")]),_vm._v(" "),_c('md-input',{model:{value:(this.teamname),callback:function ($$v) {_vm.$set(this, "teamname", $$v)},expression:"this.teamname"}}),_vm._v(" "),_c('span',{staticClass:"md-helper-text"},[_vm._v("Name your Team")])],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Twilio Account SID")]),_vm._v(" "),_c('md-input',{model:{value:(this.teamTwilioAccountSID),callback:function ($$v) {_vm.$set(this, "teamTwilioAccountSID", $$v)},expression:"this.teamTwilioAccountSID"}}),_vm._v(" "),_c('span',{staticClass:"md-helper-text"},[_vm._v("From the top of your Twilio Account Dashboard Page")])],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Twilio Auth Token")]),_vm._v(" "),_c('md-input',{model:{value:(this.teamTwilioAuthToken),callback:function ($$v) {_vm.$set(this, "teamTwilioAuthToken", $$v)},expression:"this.teamTwilioAuthToken"}}),_vm._v(" "),_c('span',{staticClass:"md-helper-text"},[_vm._v("From Right below the Account SID (click the "),_c('md-icon',[_vm._v("visibility_off")]),_vm._v(")")],1)],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Twilio SMS Number")]),_vm._v(" "),_c('md-input',{model:{value:(this.teamTwilioSMSNumber),callback:function ($$v) {_vm.$set(this, "teamTwilioSMSNumber", $$v)},expression:"this.teamTwilioSMSNumber"}}),_vm._v(" "),_c('span',{staticClass:"md-helper-text"},[_vm._v("What Twilio number will you use for Team Texting? (Use E.164 format, please.)")])],1)],1)],1)],1),_vm._v(" "),(_vm.sending)?_c('md-progress-bar',{attrs:{"md-mode":"indeterminate"}}):_vm._e(),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"xmd-primary",on:{"click":function($event){_vm.showSetup = false}}},[_vm._v("Close")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":_vm.saveSetup}},[_vm._v("Save")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveConversations_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7d7ed8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveConversations_vue__ = __webpack_require__(345);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7d7ed8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveConversations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7d7ed8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveConversations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMessage_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8dc239a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewMessage_vue__ = __webpack_require__(344);
function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8dc239a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8dc239a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-button',{staticClass:"md-fab md-fab-bottom-right",on:{"click":function($event){_vm.showSendNew = true}}},[_c('md-icon',[_vm._v("add")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("New Conversation")])],1),_vm._v(" "),_c('md-dialog',{attrs:{"md-active":_vm.showSendNew},on:{"update:mdActive":function($event){_vm.showSendNew=$event}}},[_c('md-dialog-title',[_vm._v("New Message")]),_vm._v(" "),_c('form',{staticClass:"md-layout",on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage($event)}}},[_c('md-card',{staticClass:"sendMessage"},[_c('md-field',{attrs:{"md-inline":""}},[_c('label',[_vm._v("Number")]),_vm._v(" "),_c('md-input',{ref:"numberfield",attrs:{"maxlength":"10","onfocus":"this.value = this.value"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1),_vm._v(" "),_c('md-field',[_c('label',[_vm._v("Message")]),_vm._v(" "),_c('md-textarea',{staticClass:"message",attrs:{"maxlength":"500"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendMessage($event)}},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1),_vm._v(" "),(_vm.sending)?_c('md-progress-bar',{attrs:{"md-mode":"indeterminate"}}):_vm._e(),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-secondary",on:{"click":function($event){_vm.showSendNew = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":_vm.sendMessage}},[_vm._v("Send")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.globalcontacthistory && _vm.globalcontacthistory.length)?_c('div',[_c('md-list',{staticClass:"md-double-line contactlist"},_vm._l((_vm.globalcontacthistory),function(contact,index){return _c('div',{key:contact.contactnumber},[_c('md-list-item',{class:{ activecontact: (contact.contactnumber === _vm.selectedcontactSMS)},on:{"click":function($event){_vm.selectContact(contact.contactnumber)}}},[_c('div',{staticClass:"md-list-item-text"},[_c('span',{staticClass:"name"},[_c('md-field',[_c('md-input',{attrs:{"placeholder":"(click to edit name)"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.saveName(_vm.globalcontacthistory[index].name,_vm.globalcontacthistory[index].contactnumber)}},model:{value:(_vm.globalcontacthistory[index].name),callback:function ($$v) {_vm.$set(_vm.globalcontacthistory[index], "name", $$v)},expression:"globalcontacthistory[index].name"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"smaller"},[_vm._v(_vm._s(contact.contactnumber))]),_vm._v(" "),_c('span',{staticClass:"smaller"},[_vm._v(_vm._s(_vm._f("readableTime")(contact.dateSent)))]),_vm._v(" "),_c('md-tooltip',[_vm._v("(click to edit)")])],1)]),_vm._v(" "),_c('md-divider')],1)})),_vm._v(" "),_c('NewMessage')],1):_c('div',[_c('md-empty-state',{attrs:{"md-icon":"people","md-label":"Loading...","md-description":"Loading Contacts..."}},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conversation_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c5bd80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conversation_vue__ = __webpack_require__(348);
function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59c5bd80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conversation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c5bd80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conversation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 347:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messageframe"},[(_vm.messages && _vm.messages.length)?_c('div',{ref:"messageswindow",staticClass:"messages",attrs:{"id":"messageswindow","v:onscroll":"{ this.scrolled=true }"}},_vm._l((_vm.messages),function(message){return _c('div',{key:message.sid},[_c('md-card',{class:_vm.getFloat(message.direction),attrs:{"md-with-hover":""}},[_c('md-card-header',[_vm._v("\n          "+_vm._s(message.body)+"\n          "),(message.mediaUrl)?_c('span',{staticClass:"messagemedia"},[_c('img',{attrs:{"src":message.mediaUrl}})]):_vm._e()]),_vm._v(" "),_c('md-card-content',[_vm._v("\n          "+_vm._s(_vm._f("readableTime")(message.dateSent))+"\n          "+_vm._s(message.from)+"\n        ")]),_vm._v(" "),_c('md-icon',{class:_vm.configArrow(message.direction)},[_vm._v("play_arrow")])],1)],1)})):_c('div',[_c('md-empty-state',{attrs:{"md-icon":"textsms","md-label":"Loading...","md-description":"Loading messages..."}},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"outgoing md-alignment-bottom-center"},[_c('md-field',[_c('label',[_vm._v("Outgoing:")]),_vm._v(" "),_c('md-textarea',{staticClass:"md-field outgoing",attrs:{"md-counter":"500"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.sendMessage()}},model:{value:(_vm.outgoing),callback:function ($$v) {_vm.outgoing=$$v},expression:"outgoing"}}),_vm._v(" "),_c('md-button',{staticClass:"md-fab md-mini",on:{"click":function($event){_vm.sendMessage()}}},[_c('md-icon',[_vm._v("send")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-app',{staticClass:"fullheight",attrs:{"md-waterfall":"","md-mode":"fixed"}},[_c('md-app-toolbar',{staticClass:"md-primary"},[_c('span',{staticClass:"md-title",staticStyle:{"flex":"1"}},[_vm._v("Team Texting ")]),_c('span',{staticClass:"md-title",staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm.teamname))]),_vm._v(" "),(_vm.userfirstname)?_c('span',[_vm._v(_vm._s(_vm.userfirstname + ' ' + _vm.userlastname)+" <")]):_vm._e(),_vm._v(_vm._s(_vm.useremail)),(_vm.userfirstname)?_c('span',[_vm._v(">")]):_vm._e(),_vm._v(" "),_c('md-menu',{attrs:{"md-size":"medium","md-align-trigger":""}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("\n          more_vert\n          "),_c('md-tooltip',{attrs:{"md-direction":"bottom"}},[_vm._v("Menu")])],1)],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',[_c('md-icon',[_vm._v("\n            account_circle\n          ")]),_vm._v(" "),(_vm.userfirstname)?_c('span',{staticClass:"md-list-item-text"},[_vm._v(_vm._s(_vm.userfirstname + ' ' + _vm.userlastname))]):_c('span',{staticClass:"md-list-item-text"},[_vm._v("<"+_vm._s(_vm.useremail)+">")])],1),_vm._v(" "),_c('Setup'),_vm._v(" "),_c('md-menu-item',{on:{"click":_vm.logout}},[_c('md-icon',[_vm._v("\n            cancel\n            "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_c('span',[_vm._v("Log out")])])],1),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Log Out")])],1)],1)],1)],1),_vm._v(" "),_c('md-app-drawer',{staticClass:"md-elevation-4",attrs:{"md-permanent":"clipped"}},[_c('ActiveConversations',{attrs:{"lastupdate":this.teamlastupdate}})],1),_vm._v(" "),_c('md-app-content',{staticClass:"content md-scrollbar"},[_c('Conversation',{attrs:{"contactSMS":this.selectedcontactSMS}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullheight",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Signup__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'dashbaord',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/signup',
    name: 'signup',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Signup__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }]
});

// Nav Guard
router.beforeEach(function (to, from, next) {
  // Check for requiresAuth guard
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // Check if NO logged user
    if (!__WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().currentUser) {
      // Go to login
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else if (to.matched.some(function (record) {
    return record.meta.requiresGuest;
  })) {
    // Check if NO logged user
    if (__WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().currentUser) {
      // Go to login
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else {
    // Proceed to route
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d78e15_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(355);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12d78e15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d78e15_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-alignment-center-space-around"},[_c('md-card',{attrs:{"md-with-hover":""}},[_c('md-ripple',[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Login to Team Texting")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("If you need an account, "),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("Sign up!")])],1)]),_vm._v(" "),_c('md-card-content',[_c('form',{attrs:{"action":"index.html"}},[_c('md-field',[_c('label',[_c('md-icon',[_vm._v("email")]),_vm._v("Email Address")],1),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('md-field',[_c('label',[_c('md-icon',[_vm._v("lock")]),_vm._v("Password")],1),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)]),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":_vm.login}},[_vm._v("Login")])],1)],1)],1),_vm._v(" "),_c('md-snackbar',{attrs:{"md-active":_vm.showSnackbar},on:{"update:mdActive":function($event){_vm.showSnackbar=$event}}},[_c('span',[_vm._v(_vm._s(this.errormessage))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5824b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(358);
function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e5824b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5824b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 357:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-alignment-center-space-around"},[_c('md-card',{attrs:{"md-with-hover":""}},[_c('md-ripple',[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Create an account for Team Texting")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("If you already have an account, "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Log in!")])],1)]),_vm._v(" "),_c('md-card-content',[_c('form',{attrs:{"action":"index.html"}},[_c('md-field',[_c('label',[_c('md-icon',[_vm._v("email")]),_vm._v("Email Address")],1),_vm._v(" "),_c('md-input',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.maybesignup($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('md-field',[_c('label',[_c('md-icon',[_vm._v("lock")]),_vm._v("Password")],1),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signup($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)]),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":_vm.signup}},[_vm._v("Sign up!")])],1)],1)],1),_vm._v(" "),_c('md-snackbar',{attrs:{"md-active":_vm.showSnackbar},on:{"update:mdActive":function($event){_vm.showSnackbar=$event}}},[_c('span',[_vm._v(_vm._s(this.errormessage))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_map_fields__ = __webpack_require__(37);



// import firebase from 'firebase'



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    userfirstname: null,
    userlastname: null,
    useremail: null,
    usercolor: null,
    userlevel: null,
    userTwilioAccountSID: null,
    teamTwilioAccountSID: null,
    teamTwilioAuthToken: null,
    teamTwilioSMSNumber: null,
    teamname: null,
    teamlastupdate: null,
    selectedcontactSMS: null,
    globalcontacthistory: null,
    forceConversationUpdate: null
  },
  actions: {
    getContactHistory: function getContactHistory(context) {
      var endpoint = 'https://api.cvstech.com/twilio/contacthistory/';
      console.log('Getting Contact History...');
      console.log(context.state.teamTwilioSMSNumber);
      if (context.state.teamTwilioSMSNumber) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + context.state.teamTwilioSMSNumber, { sid: context.state.teamTwilioAccountSID, token: context.state.teamTwilioAuthToken }).then(function (response) {
          context.state.globalcontacthistory = response.data;
          // console.log(context.state.globalcontacthistory)
          if (!context.state.selectedcontactSMS) {
            context.state.selectedcontactSMS = context.state.globalcontacthistory[1].contactnumber;
            setTimeout(context.state.selectedcontactSMS = context.state.globalcontacthistory[0].contactnumber, 150);
          }
          context.dispatch('getCallerIDnames');
        }).catch(function (error) {
          console.log('----- getContactHistory error-------');
          console.log(error);
          console.log('----- getContactHistory error-------');
        });
        console.log('setting up snapshot for ' + context.state.teamTwilioAccountSID);
        __WEBPACK_IMPORTED_MODULE_3__services_firebase__["a" /* default */].collection('teams').doc(context.state.teamTwilioAccountSID).collection('contacts').onSnapshot(function (snapshot) {
          console.log('update to contacts detected...');
          snapshot.forEach(function (doc) {
            for (var i = 0; i < context.state.globalcontacthistory.length; i++) {
              if (context.state.globalcontacthistory[i]['contactnumber'] === doc.id) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(context.state.globalcontacthistory[i], name, doc.data().name);
                console.log(context.state.globalcontacthistory[i].name);
              }
            }
          });
        });
      } else {
        console.log('Not ready. Wait 250ms...');
        setTimeout(store.dispatch('getContactHistory'), 250);
      }
    },
    getCallerIDnames: function getCallerIDnames(context, payload) {
      console.log('getting caller id names');
      context.state.globalcontacthistory.forEach(function (contact) {
        __WEBPACK_IMPORTED_MODULE_3__services_firebase__["a" /* default */].collection('teams').doc(context.state.teamTwilioAccountSID).collection('contacts').doc(contact.contactnumber).get().then(function (doc) {
          if (doc.id) {
            if (doc.data().name === null) {
              console.log('getCallerIDnames -- doc.data().name === null');
              console.log(doc.id);
              console.log(doc.data());
              console.log('getCallerIDnames -- doc.data().name === null');
              store.dispatch('updatecontactRecord', { contactnumber: doc.id, data: doc });
            } else {
              for (var i = 0; i < context.state.globalcontacthistory.length; i++) {
                if (context.state.globalcontacthistory[i].contactnumber === contact.contactnumber) {
                  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(context.state.globalcontacthistory[i], 'name', doc.data().name);
                  if (doc.data().lastviewed) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(context.state.globalcontacthistory[i], 'lastviewed', doc.data().lastviewed);
                  } else {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(context.state.globalcontacthistory[i], 'lastviewed', 1000000000);
                  }
                }
              }
            }
          } else {
            console.log('No doc.id');
          }
        });
      });
    },
    updatecontactRecord: function updatecontactRecord(context, payload) {
      var number = payload.contactnumber;
      var lookupendpoint = 'https://api.cvstech.com/twilio/lookup/';
      console.log('===--- ' + payload.data.id + ' ---===');
      console.log(payload);
      if (payload.data.id) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(lookupendpoint + number, { sid: context.state.teamTwilioAccountSID, token: context.state.teamTwilioAuthToken }).then(function (response) {
          var newname = '';
          if (payload.data.name) {
            newname = payload.data.name;
          }
          console.log('saving ' + newname + ' to ' + number);
          __WEBPACK_IMPORTED_MODULE_3__services_firebase__["a" /* default */].collection('teams').doc(context.state.teamTwilioAccountSID).collection('contacts').doc(number).update({ name: newname });
          for (var i = 0; i < context.state.globalcontacthistory.length; i++) {
            if (context.state.globalcontacthistory[i].contactnumber === number) {
              __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(context.state.globalcontacthistory[i], name, newname);
            }
          }
        });
      }
    }
  },
  mutations: {
    updateField: __WEBPACK_IMPORTED_MODULE_4_vuex_map_fields__["c" /* updateField */]
  },
  getters: {
    getField: __WEBPACK_IMPORTED_MODULE_4_vuex_map_fields__["a" /* getField */]
  },
  modules: {}
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);



var config = {
  apiKey: 'AIzaSyBYGroXqzrWUvWOPRFUPnmnhnOQTwG14d4',
  authDomain: 'teamtexting-cvstech.firebaseapp.com',
  databaseURL: 'https://teamtexting-cvstech.firebaseio.com',
  projectId: 'teamtexting-cvstech',
  storageBucket: 'teamtexting-cvstech.appspot.com',
  messagingSenderId: '440344335724'
};
var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

/* harmony default export */ __webpack_exports__["a"] = (firebaseApp.firestore());

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard__ = __webpack_require__(151);

//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Dashboard: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex_map_fields__["b" /* mapFields */])(['userfirstname', 'userlastname', 'useremail', 'usercolor', 'userlevel', 'userTwilioAccountSID', 'teamTwilioAccountSID', 'teamTwilioAuthToken', 'teamTwilioSMSNumber', 'teamname', 'teamlastupdate', 'teamlastcommfrom', 'forceConversationUpdate', 'globalcontacthistory'])),
  beforeCreate: function beforeCreate() {
    var self = this;
    self.forceConversationUpdate = false;
    self.globalcontacthistory = [];
    self.globalcontacthistorywithnames = [];
    if (__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser) {
      self.userdata = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
      __WEBPACK_IMPORTED_MODULE_2__services_firebase__["a" /* default */].collection('users').doc(self.userdata.email).get().then(function (doc) {
        if (doc.exists) {
          self.userfirstname = doc.data().firstname;
          self.userlastname = doc.data().lastname;
          self.useremail = self.userdata.email;
          self.usercolor = doc.data().color;
          self.userlevel = doc.data().level;
          self.userTwilioAccountSID = doc.data().TwilioAccountSID;
          console.log('---------- Data loaded for user: ' + self.useremail);
          self.loadTeam(self.userTwilioAccountSID);
        } else {
          console.log('Doc does not exist at ' + self.useremail);
        }
      });
    } else {
      console.log('unauthed');
      console.log(self.$route);
      if (self.$route.params.number) {
        var rightnow = Math.floor(Date.now() / 1000);
        console.log('Created UpdateNotice: ' + rightnow);
        console.log(self.$route.params.number);
        __WEBPACK_IMPORTED_MODULE_2__services_firebase__["a" /* default */].collection('teams').doc(self.$route.params.sid).update({
          teamlastcommfrom: self.$route.params.number,
          teamlastupdate: rightnow
        }).catch(function (error) {
          console.log('-----error-------');
          console.log(error);
        });
      }
    }
  },

  methods: {
    loadTeam: function loadTeam(tsid) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__services_firebase__["a" /* default */].collection('teams').doc(tsid).get().then(function (doc) {
        if (doc.exists) {
          self.teamTwilioAuthToken = doc.data().TwilioAuthToken;
          self.teamTwilioSMSNumber = doc.data().TwilioSMSNumber;
          self.teamTwilioAccountSID = doc.data().TwilioAccountSID;
          self.teamlastupdate = doc.data().teamlastupdate;
          self.teamlastcommfrom = doc.data().teamlastcommfrom;
          self.teamname = doc.data().teamname;
          console.log('------------- Team Configuration loaded!');
          __WEBPACK_IMPORTED_MODULE_2__services_firebase__["a" /* default */].collection('teams').doc(tsid).onSnapshot({
            includeMetadataChanges: true
          }, function (doc) {
            self.teamlastupdate = doc.data().teamlastupdate;
            self.teamlastcommfrom = doc.data().teamlastcommfrom;
            self.$store.dispatch('getContactHistory');
          });
        } else {
          console.log('Team does not exist at ' + tsid);
        }
      });
    }
  }
});

/***/ })

},[164]);


// WEBPACK FOOTER //
// static/js/app.81f59c9367c65b1eb1ad.js